import { render, staticRenderFns } from "./ab-save.vue?vue&type=template&id=5f7379c2"
import script from "./ab-save.vue?vue&type=script&lang=js"
export * from "./ab-save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports